const ResponseCodes = {
  APPROVED: '000',
  PARTIALLY_APPROVED: '010',
  INSUFFICIENT_FUNDS: '110',
  ALREADY_DEPLETED: '111',
  EXCEEDS_APPROVAL_AMOUNT_LIMIT: '127',
  CARDHOLDER_TRANSACTION_NOT_PERMITTED: '327',
  DO_NOT_HONOR: '349',
  INVALID_TRANSACTION: '322',
  EXPIRED_CARD: '305',
  ACCOUNT_CHANGED: '500',
  THE_ACCOUNT_WAS_CLOSED: '501',
  SUSPECTED_FRAUD: '555',
  ECHECK_TOKEN_REGISTERED: '801',
  REGISTRED_PREVIOUSLY: '802',
  CARD_NUMBER_UPDATED: '805',
  _Values: () =>
    Object.keys(ResponseCodes)
      .filter(key => typeof ResponseCodes[key] !== 'function')
      .map(key => ResponseCodes[key]),
};

// These are the error codes that the users face in majority of times when
// their payments fails.
// https://domuso.atlassian.net/browse/ENG-1068
const FrequentErrorCodes = new Set([
  ResponseCodes.INSUFFICIENT_FUNDS,
  ResponseCodes.EXCEEDS_APPROVAL_AMOUNT_LIMIT,
  ResponseCodes.DO_NOT_HONOR,
  ResponseCodes.INVALID_TRANSACTION,
  ResponseCodes.EXPIRED_CARD,
  ResponseCodes.THE_ACCOUNT_WAS_CLOSED,
  ResponseCodes.SUSPECTED_FRAUD,
  ResponseCodes.CARDHOLDER_TRANSACTION_NOT_PERMITTED,
]);

const ApprovedCapturedCodes = new Set([
  ResponseCodes.APPROVED,
  ResponseCodes.REGISTRED_PREVIOUSLY,
  ResponseCodes.ECHECK_TOKEN_REGISTERED,
  ResponseCodes.CARD_NUMBER_UPDATED,
  ResponseCodes.ACCOUNT_CHANGED,
]);

const ApprovedRegisterCodes = new Set([
  ResponseCodes.APPROVED,
  ResponseCodes.REGISTRED_PREVIOUSLY,
  ResponseCodes.ECHECK_TOKEN_REGISTERED,
  ResponseCodes.CARD_NUMBER_UPDATED,
]);

const ApprovedAuthorizationCodes = new Set([
  ResponseCodes.APPROVED,
  ResponseCodes.REGISTRED_PREVIOUSLY,
  ResponseCodes.ECHECK_TOKEN_REGISTERED,
  ResponseCodes.CARD_NUMBER_UPDATED,
]);

const CardValidationResponseCodes = {
  M: 'Match',
  N: 'No Match',
  P: 'Not Processed',
  S: 'CVV2 should have been on the card, but merchant indicated CVV2 is not present',
  U: 'Issuer is not certified for CVV2/CVC2/CID processing',
  _Values: () =>
    Object.keys(CardValidationResponseCodes)
      .filter(key => typeof CardValidationResponseCodes[key] !== 'function')
      .map(key => CardValidationResponseCodes[key]),
};

const AvsResponseCodesMap = {
  '00': '5-Digit zip and address match',
  '01': '9-Digit zip and address match',
  '02': 'Postal code and address match',
  '10': '5-Digit zip matches: address does not match',
  '11': '9-Digit zip matches: address does not match',
  '12': 'Zip does not match: address matches',
  '13': 'Postal code does not match: address matches',
  '14': 'Postal code matches: address not verified',
  '20': 'Neither zip nor address match',
  '30': 'AVS service not supported by issuer',
  '31': 'AVS system not available',
  '32': 'Address unavailable',
  '33': 'General error',
  '34': 'AVS not performed',
  '40': 'Address failed Litle & Co. edit checks',
  _Values: () =>
    Object.keys(AvsResponseCodesMap)
      .filter(key => typeof AvsResponseCodesMap[key] !== 'function')
      .map(key => AvsResponseCodesMap[key]),
};

module.exports = {
  ApprovedRegisterCodes,
  ApprovedCapturedCodes,
  ApprovedAuthorizationCodes,
  FrequentErrorCodes,
  ResponseCodes,
  CardValidationResponseCodes,
  AvsResponseCodesMap,
};
